import { useCart } from "../../../store/hooks/useCart";
import { useCartSelections } from "../../../store/hooks/useCartSelections";

export const useHasSelectedOptionalTools = (): boolean => {
  const cart = useCart();
  const cartSelections = useCartSelections();

  if (
    cart?.optional?.toolsProductItems &&
    cart?.optional?.toolsProductItems.length > 0
  ) {
    return true;
  }

  if (
    cartSelections?.optional?.toolsProductItems &&
    cartSelections?.optional?.toolsProductItems.length > 0
  ) {
    return true;
  }

  return false;
};
